import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TipLinkComponent } from './tip-link.component';

@NgModule({
    imports: [ CommonModule ],
    exports: [ TipLinkComponent ],
    declarations: [ TipLinkComponent ],
})
export class TipLinkModule {}
